import React from 'react';

const VerifyDomain = (props) => {

    if(isEmitirNotasDomain()){
        return redirectContentsys();
    }

    return (<>
        {[props.children]}
    </>);


}

const redirectContentsys = () => {
    window.location = 'https://pedidos.contentsys.com.br';
    return <></>
}

const isEmitirNotasDomain = () => {
    // return window.location.href.indexOf('emitirnotas.com.br') >= 0;
    return window.location.href.indexOf('emitirnotas.com.br') >= 0;
}

export {VerifyDomain};